module.exports = __webpack_public_path__ + "assets/images/boundaries/details/6-members.svg?v=b0229c42";